import React, { useEffect, useState } from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";
const tooltipStyle = {
  contentStyle: { background: "#0d0d0d", border: "1px solid #00ff9033", borderRadius: 8, fontSize: 11 },
  labelStyle: { color: "#00ff90" },
};

function fmt(n) { return `₹${n >= 100000 ? `${(n / 100000).toFixed(1)}L` : n >= 1000 ? `${(n / 1000).toFixed(0)}k` : n}`; }

export default function TrendChart({ month }) {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${API}/api/admin/payroll/trend?months=6&to=${month}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => setData(Array.isArray(d) ? d : d?.data || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [month]);

  if (loading) return (
    <div className={`${card} p-5`}>
      <div className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium mb-4">Net Pay Trend</div>
      <div className="h-36 rounded-lg bg-white/5 animate-pulse" />
    </div>
  );

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Net Pay Trend</span>
        <span className="text-xs text-white/30">6 months</span>
      </div>
      <div className="p-5">
        {data.length === 0 ? (
          <p className="text-white/20 text-sm italic text-center py-4">No trend data available.</p>
        ) : (
          <ResponsiveContainer width="100%" height={140}>
            <AreaChart data={data} margin={{ top: 4, right: 4, left: -10, bottom: 0 }}>
              <CartesianGrid stroke="rgba(255,255,255,0.04)" />
              <XAxis dataKey="month" tick={{ fontSize: 9, fill: "rgba(255,255,255,0.3)" }} />
              <YAxis tick={{ fontSize: 9, fill: "rgba(255,255,255,0.25)" }} tickFormatter={fmt} width={48} />
              <Tooltip {...tooltipStyle} formatter={v => [fmt(v), "Net Pay"]} />
              <Area type="monotone" dataKey="net" stroke="#00ff90" fill="#00ff9015" strokeWidth={2} />
              {data[0]?.gross && (
                <Area type="monotone" dataKey="gross" stroke="#60a5fa" fill="#60a5fa10" strokeWidth={1.5} strokeDasharray="4 2" />
              )}
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}